import MetadonnesHeader from "./components/metadonnesHeader";
import AddEditMetadonnes from "./components/AddEdit/addEdit";
import MetadonnesTable from "./components/List/metadonnesTable";
import { useAppSelector } from "../../Redux/hooks";

const Metadonnes = () => {
  const showDivCondition = useAppSelector(
    (state) => state.MetadonnesReducer.showDivsConditionsMetadonnes
  );

  return (
    <div>
      {!showDivCondition.addMetadonnes ? (
        <div>
          <MetadonnesHeader />
          <MetadonnesTable />
        </div>
      ) : (
        <div>
          <MetadonnesHeader />
          <AddEditMetadonnes />
        </div>
      )}
    </div>
  );
};

export default Metadonnes;
